import { mapActions } from 'vuex'

import BaseESignOnboarding from './BaseESignOnboarding.vue'

const SellerESignOnboarding = BaseESignOnboarding.extend({
  name: 'SellerESignOnboarding',

  methods: {
    ...mapActions('account', {
      getPendingDocumentBundleStatusForAccount: 'getPendingDocumentBundleStatusForSeller',
      createOnboardingDocsForAccount: 'createOnboardingDocsForSeller'
    }),
  }
})

export default SellerESignOnboarding